import { render, staticRenderFns } from "./NovaPagina.vue?vue&type=template&id=677dfd16"
import script from "./NovaPagina.vue?vue&type=script&lang=js"
export * from "./NovaPagina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports